import { render, staticRenderFns } from "./BaseDisplay.vue?vue&type=template&id=eda06320&"
import script from "./BaseDisplay.vue?vue&type=script&lang=js&"
export * from "./BaseDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports